import { HttpContextToken, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize } from 'rxjs/operators';
import { BusyIndicatorService } from '../../services/busy-indicator.service';

export const IGNORE_BUSY_INDICATOR = new HttpContextToken<boolean>(() => false);

export const busyIndicatorInterceptor: HttpInterceptorFn = (request, next) => {
  const busyIndicatorService = inject(BusyIndicatorService);

  if (isSvgIconRequest(request) || shouldIgnoreBusyIndicator(request)) return next(request);

  busyIndicatorService.newOperation();
  return next(request).pipe(
    catchError((err) => {
      throw err;
    }),
    finalize(() => {
      busyIndicatorService.operationFinished();
    }),
  );
};

function isSvgIconRequest(request: HttpRequest<any>): boolean {
  const url = request.url.split('?')[0];
  return url.toLowerCase().endsWith('.svg');
}

function shouldIgnoreBusyIndicator(request: HttpRequest<any>): boolean {
  return request.context.get(IGNORE_BUSY_INDICATOR);
}
